import { registerMockAPI } from '~/mocks/mockApis';

import {
  type TypeCreateGuestAccountsPhoneVerificationVerifyRequest,
  type TypeCreateGuestAccountsPhoneVerificationVerifyResponse,
} from '~/api/guestAccounts/types';
import { axiosInstance } from '~/services/fetchServiceV2';

import { useDedupeMutation } from '../common';

/**
 * @description 비회원 본인인증 및 정보 생성/수정 api에 사용되는 커스텀 훅
 */
export const useVerifyGuest = () => {
  return useDedupeMutation<
    TypeCreateGuestAccountsPhoneVerificationVerifyRequest,
    TypeCreateGuestAccountsPhoneVerificationVerifyResponse
  >({
    mutationFn: (params: TypeCreateGuestAccountsPhoneVerificationVerifyRequest) => {
      const endpoint = '/guest-accounts/phone-verification/verify';
      return axiosInstance.post(endpoint, params, { headers: { withoutToken: true } });
    },
  });
};

registerMockAPI<TypeCreateGuestAccountsPhoneVerificationVerifyResponse>({
  method: 'post',
  endpoint: '/guest-accounts/phone-verification/verify',
  label: '근무 지원 정보/비회원 인증번호 검증',
  scenarios: [
    {
      name: '성공',
      response: {
        code: '0000',
        message: '정상',
        data: {
          isMember: false,
          guestToken: 'temp-guest-token',
        },
      },
    },
    {
      name: '실패',
      response: {
        code: '500',
        message: '서버 내부 오류가 발생했습니다.',
        data: {
          isMember: false,
          guestToken: '',
        },
      },
      status: 500,
    },
  ],
});
